import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/css/main.css";
import "./assets/css/page_not_found.css";

Vue.config.productionTip = false

new Vue({
  router,
  store,
  mode: "",
  render: h => h(App)
}).$mount('#app')
